import React from "react";
import classNames from "classnames";
import T from "prop-types";
import { ATL, BBTL, BTL, SATL, ZTL } from "MODULES/parts/constants";
import { getPartNumberColorClassNameByTierType } from "MODULES/shared/helpers";
import { connect } from "react-redux";
import { update } from "MODULES/parts/actions";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import {
  BUYER_MANAGER,
  CAN_ADD_UPDATE_PARTS,
  SALES,
  SALES_MANAGER
} from "MODULES/users/constants";
import { hasPermission, hasRole, hasSubRole } from "MODULES/users/helpers";

const tierTypeScore = {
  [SATL]: 5,
  [ATL]: 4,
  [BTL]: 3,
  [BBTL]: 2,
  [ZTL]: 1
};

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export function Stars({
  tierType,
  style = {},
  updatePart,
  disabled = true,
  size = ""
}) {
  const currentUser = useCurrentUser();
  const canClick =
    hasRole(currentUser, SALES) ||
    hasSubRole(currentUser, [BUYER_MANAGER, SALES_MANAGER]) ||
    (hasPermission(currentUser, CAN_ADD_UPDATE_PARTS) && !disabled);

  const classes = classNames(getPartNumberColorClassNameByTierType(tierType), {
    clickable: canClick
  });

  const onClick = canClick ? updatePart : () => {};

  const stars = Array.from({ length: 5 }, (_, i) => {
    if (i < (tierTypeScore[tierType] || 0)) {
      return (
        <i
          className={`fa fa-star ${size}`}
          onClick={() => onClick(getKeyByValue(tierTypeScore, i + 1))}
        />
      );
    }
    return (
      <i
        className={`fa fa-star-o ${size}`}
        onClick={() => onClick(getKeyByValue(tierTypeScore, i + 1))}
      />
    );
  });

  return (
    <div className={`score-wrap ${classes}`} style={style}>
      {stars}
    </div>
  );
}

export default connect(undefined, (dispatch, ownProps) => ({
  updatePart: tierType =>
    dispatch(
      update({ tier_type: tierType === ownProps.tierType ? null : tierType })
    )
}))(Stars);

Stars.propTypes = {
  disabled: T.bool,
  style: T.shape({}),
  size: T.string,
  tierType: T.string,
  updatePart: T.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Stars/Stars.jsx